module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "vueDeletionConfirmationModal",
      "tabindex": "-1 ",
      "role": "dialog ",
      "aria-labelledby": "vueDeletionConfirmationLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.cancelAction
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Remove Item(s)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n                Are you sure you want to remove the item(s) from your shopping cart?\n                "), _c('div', {
    staticClass: "btn-wrap text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.submitData
    }
  }, [_vm._v("Remove")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.cancelAction
    }
  }, [_vm._v("Cancel")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b0bd4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/deletion-confirmation.vue
// module id = FjH/
// module chunks = 1